export { default, type RawProps as BlockquoteSectionProps } from './BlockquoteSection';
